import { Worktime as LegacyWorktime } from "./worktime";
import { Drives } from "./drives";
import { Tasks } from "./tasks";
export const Worktime = {
    ...LegacyWorktime,
    modules: {
        ...(LegacyWorktime.modules || {}),
        drives: Drives,
        tasks: Tasks
    }
};
